import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default class Cards {
  constructor(el) {
    this.el = el
    this.bg = el.querySelector('.cards--bg')
    this.items = el.querySelectorAll('.cards--item')
    if (this.items.length) this.init()
  }

  init() {
    const isDesktop = window.matchMedia('(min-width: 992px)').matches

    if (isDesktop) {
      gsap.fromTo(this.bg,
        { scale: 0.88 },
        {
          scale: 1,
          ease: 'none',
          scrollTrigger: {
            trigger: this.el,
            start: 'top bottom',
            end: 'center center',
            scrub: 1.5,
          }
        }
      )
    }

    gsap.fromTo(this.items,
      { opacity: 0, y: 40 },
      {
        opacity: 1,
        y: 0,
        duration: 0.7,
        ease: 'power2.out',
        stagger: 0.15,
        scrollTrigger: {
          trigger: this.el,
          start: 'top 80%',
          toggleActions: 'play none none none',
        }
      }
    )
  }
}
